import { DoodCartModel } from '@core/models/cart.model';

// Shallow content check via JSON stringify. Covers the vast majority of
// meaningful changes (products, quantities, coupons, wanted_at, ...) at the
// cost of re-serializing on each emission. Good enough for high-level
// reactive pipelines where we want to avoid duplicated downstream calls.
export function isSameCartContent(
  a: DoodCartModel | null | undefined,
  b: DoodCartModel | null | undefined,
): boolean {
  if (a === b) return true;
  if (!a || !b) return false;
  return JSON.stringify(a) === JSON.stringify(b);
}
